// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"561efe5f","79":"ff9369b5","192":"561efe5f","498":"561efe5f","700":"6106d975","796":"561efe5f"}[chunkId] + ".chunk.css";
};